import { format } from 'date-fns'
import PropTypes from 'prop-types'
import { DatePickerInput } from './date-picker-input'

const StringDatePickerInput = ({
  label,
  value, // Expects string in yyyy-MM-dd format
  onChange, // Receives string in yyyy-MM-dd format
  placeholder,
  helpText,
  className,
  disableFuture = false,
  disabled = false,
}) => {
  // Convert string to Date for internal use with DatePickerInput
  const dateValue = value
    ? (() => {
        try {
          const date = new Date(value + 'T00:00:00')
          return isNaN(date.getTime()) ? null : date
        } catch {
          return null
        }
      })()
    : null

  // Convert Date back to string for onChange callback
  const handleChange = date => {
    if (date) {
      onChange(format(date, 'yyyy-MM-dd')) // Return yyyy-MM-dd string
    } else {
      onChange(null)
    }
  }

  return (
    <DatePickerInput
      label={label}
      value={dateValue}
      onChange={handleChange}
      placeholder={placeholder}
      helpText={helpText}
      className={className}
      disableFuture={disableFuture}
      disabled={disabled}
    />
  )
}

export { StringDatePickerInput }

StringDatePickerInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string, // String in yyyy-MM-dd format
  onChange: PropTypes.func, // Receives string in yyyy-MM-dd format or null
  placeholder: PropTypes.string,
  helpText: PropTypes.node,
  className: PropTypes.string,
  disableFuture: PropTypes.bool,
  disabled: PropTypes.bool,
}
